function toggleAccordion(header) {
    const content = header.nextElementSibling;
    const icon = header.querySelector('.icon-caret');
    const icon_circle = header.querySelector('.icon-circle_caret');
    content.classList.toggle('open');

    if (content.classList.contains('open')) {
        content.style.maxHeight = content.scrollHeight + 'px';

        if (icon) icon.classList.add('icon-rotate');
        if (icon_circle) icon_circle.classList.add('icon-rotate');
    } else {
        content.style.maxHeight = 0;
        if (icon) icon.classList.remove('icon-rotate');
        if (icon_circle) icon_circle.classList.remove('icon-rotate');
    }
}